import { render } from "./ManageClaims.vue?vue&type=template&id=36df69cc"
import script from "./ManageClaims.vue?vue&type=script&lang=js"
export * from "./ManageClaims.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__